var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { ref: "voucherInfo", attrs: { model: _vm.deviceMaintPlan } },
    [
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("基础信息")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("标题")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "title",
                    rules: { validator: _vm.checkNull, trigger: "blur" }
                  }
                },
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入标题" },
                    model: {
                      value: _vm.deviceMaintPlan.title,
                      callback: function($$v) {
                        _vm.$set(_vm.deviceMaintPlan, "title", $$v)
                      },
                      expression: "deviceMaintPlan.title"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("周期保养")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "cronFlag" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.checkInfo },
                      model: {
                        value: _vm.deviceMaintPlan.cronFlag,
                        callback: function($$v) {
                          _vm.$set(_vm.deviceMaintPlan, "cronFlag", $$v)
                        },
                        expression: "deviceMaintPlan.cronFlag"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("是")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("否")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        !_vm.deviceMaintPlan.cronFlag
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("保养时间")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "theDateTime",
                        rules: {
                          validator: _vm.checkTheDateTime,
                          trigger: "blur"
                        }
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetime",
                          "picker-options": _vm.pickerOptions0,
                          placeholder: "选择日期时间",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.deviceMaintPlan.theDateTime,
                          callback: function($$v) {
                            _vm.$set(_vm.deviceMaintPlan, "theDateTime", $$v)
                          },
                          expression: "deviceMaintPlan.theDateTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.deviceMaintPlan.cronFlag
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("保养时间")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "theExprDesc",
                        rules: { validator: _vm.checkNull, trigger: "blur" }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.deviceMaintPlan.theExprDesc || ""))
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "swb-btn-link",
                          on: { click: _vm.selectCronInfo }
                        },
                        [_vm._v("选择周期")]
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.deviceMaintPlan.cronFlag
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("保养截止时间")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "limitEndTime",
                        rules: { validator: _vm.checkNone, trigger: "blur" }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.deviceMaintPlan.limitEndTime || "无"))
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("保养范围")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.suitFlagChange },
                      model: {
                        value: _vm.deviceMaintPlan.suitFlag,
                        callback: function($$v) {
                          _vm.$set(_vm.deviceMaintPlan, "suitFlag", $$v)
                        },
                        expression: "deviceMaintPlan.suitFlag"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("标准资产")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("套装资产")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("保养资产")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hint block" }, [
        _c("div", { staticClass: "title" }, [_vm._v("温馨提示")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "1、线上采购且在保内的商品是约定期保内，其他情况均为约定期保外"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("2、根据选定的页签选择的资产会自动过滤约定期保内、约定期保外")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-small",
              on: {
                click: function($event) {
                  _vm.selectDevice()
                }
              }
            },
            [_vm._v("选择资产")]
          ),
          _vm._v(" "),
          (_vm.deviceMaintPlan.deviceSubNoWrntList != null &&
            _vm.deviceMaintPlan.deviceSubNoWrntList.length > 0) ||
          (_vm.deviceMaintPlan.deviceSubNoCatList != null &&
            _vm.deviceMaintPlan.deviceSubNoCatList.length > 0)
            ? _c(
                "a",
                {
                  staticClass: "swb-btn swb-btn-small",
                  on: {
                    click: function($event) {
                      _vm.setYqInfo(
                        _vm.deviceMaintPlan.cronFlag,
                        _vm.deviceMaintPlan.theDateTime
                      )
                    }
                  }
                },
                [_vm._v("设置工单截止要求")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c("span", [_vm._v("共" + _vm._s(_vm.selectCount) + "条")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tab-container small base pos-rel" }, [
        _c("div", { staticClass: "tabs-nav" }, [
          _c(
            "ul",
            { staticClass: "head" },
            _vm._l(_vm.tableState, function(status) {
              return _c(
                "li",
                {
                  staticClass: "head-item",
                  class: { current: status.value == _vm.checkStateValue },
                  on: {
                    click: function($event) {
                      _vm.handleTabClick(status.value)
                    }
                  }
                },
                [_c("span", [_vm._v(_vm._s(status.text))])]
              )
            })
          )
        ])
      ]),
      _vm._v(" "),
      _vm.checkStateValue == 0
        ? _c(
            "div",
            {
              staticClass: "table-layout",
              staticStyle: { "overflow-x": "auto" }
            },
            [
              _c("table", { staticClass: "custom-tbl error-prompt" }, [
                _c("thead", { staticClass: "head" }, [
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "th",
                      { staticStyle: { "text-align": "left", width: "155px" } },
                      [_vm._v("资产名称")]
                    ),
                    _vm._v(" "),
                    _vm.deviceMaintPlan.suitFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              "text-align": "left",
                              width: "155px"
                            }
                          },
                          [_vm._v("套装名称")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "th",
                      { staticStyle: { "text-align": "left", width: "240px" } },
                      [_vm._v("系统编号")]
                    ),
                    _vm._v(" "),
                    _c("th", { staticStyle: { width: "155px" } }, [
                      _vm._v("质保到期时间")
                    ]),
                    _vm._v(" "),
                    _c(
                      "th",
                      { staticStyle: { "text-align": "left", width: "200px" } },
                      [_vm._v("供应商名称")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      { staticStyle: { "text-align": "left", width: "200px" } },
                      [_vm._v("服务商名称")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      { staticStyle: { "text-align": "left", width: "150px" } },
                      [_vm._v("基于合同")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "required",
                        staticStyle: { "text-align": "left", width: "150px" }
                      },
                      [_vm._v("服务名称")]
                    ),
                    _vm._v(" "),
                    _vm.deviceMaintPlan.cronFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              "text-align": "center",
                              width: "242px"
                            }
                          },
                          [_vm._v("首次工单截止时间")]
                        )
                      : _c(
                          "th",
                          {
                            staticStyle: {
                              "text-align": "center",
                              width: "242px"
                            }
                          },
                          [_vm._v("工单截止时间")]
                        ),
                    _vm._v(" "),
                    _vm.deviceMaintPlan.cronFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              "text-align": "right",
                              width: "120px"
                            }
                          },
                          [_vm._v("要求完成小时")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "right", width: "120px" }
                      },
                      [_vm._v("提前预警小时")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      { staticStyle: { "text-align": "left", width: "216px" } },
                      [_vm._v("操作")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.deviceMaintPlan.deviceSubNoWrntList != null &&
                _vm.deviceMaintPlan.deviceSubNoWrntList.length > 0
                  ? _c(
                      "tbody",
                      { staticClass: "body" },
                      _vm._l(_vm.deviceMaintPlan.deviceSubNoWrntList, function(
                        deviceSubNo,
                        index
                      ) {
                        return _c("tr", { staticClass: "row" }, [
                          _c(
                            "td",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { title: deviceSubNo.title }
                            },
                            [_vm._v(_vm._s(deviceSubNo.title))]
                          ),
                          _vm._v(" "),
                          _vm.deviceMaintPlan.suitFlag
                            ? _c(
                                "td",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { title: deviceSubNo.suitName || "无" }
                                },
                                [_vm._v(_vm._s(deviceSubNo.suitName || "无"))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "left" } }, [
                            _vm._v(_vm._s(deviceSubNo.tmpNo))
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(deviceSubNo.wrntDueTime))]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              {
                                attrs: {
                                  title: _vm.roleMerchtVendor(deviceSubNo)
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.roleMerchtVendor(deviceSubNo))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              {
                                attrs: {
                                  title: _vm.roleMerchtServicer(deviceSubNo)
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.roleMerchtServicer(deviceSubNo))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            deviceSubNo.contractId != null
                              ? _c("span", [_vm._v("是")])
                              : _c("span", [_vm._v("否")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { title: deviceSubNo.servcTitle || "无" }
                            },
                            [_vm._v(_vm._s(deviceSubNo.servcTitle || "无"))]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticStyle: { "text-align": "center" } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      "picker-options": _vm.pickerOptions0,
                                      type: "datetime",
                                      placeholder: "请选择"
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.yqFinishTimeChange(deviceSubNo)
                                      }
                                    },
                                    model: {
                                      value: deviceSubNo.yqFinishTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          deviceSubNo,
                                          "yqFinishTime",
                                          $$v
                                        )
                                      },
                                      expression: "deviceSubNo.yqFinishTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.deviceMaintPlan.cronFlag
                            ? _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(deviceSubNo.yqFinishHours))
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticStyle: { "text-align": "right" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "deviceSubNoWrntList." +
                                      index +
                                      ".yqFinishAotHr",
                                    rules: {
                                      validator: _vm.inputYqFinishAotHr,
                                      trigger: "blur"
                                    }
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "input-content-right",
                                    attrs: { type: "number", min: "0" },
                                    on: {
                                      change: function($event) {
                                        _vm.quantityYqFinishAotHr(deviceSubNo)
                                      }
                                    },
                                    model: {
                                      value: deviceSubNo.yqFinishAotHr,
                                      callback: function($$v) {
                                        _vm.$set(
                                          deviceSubNo,
                                          "yqFinishAotHr",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "deviceSubNo.yqFinishAotHr"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "left" } }, [
                            deviceSubNo.ssuId == null
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.selectMsu(deviceSubNo)
                                      }
                                    }
                                  },
                                  [_vm._v("选择服务")]
                                )
                              : _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.removeMsu(deviceSubNo)
                                      }
                                    }
                                  },
                                  [_vm._v("移除服务")]
                                ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.deleteSelectDeviceSubNo(index)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          ])
                        ])
                      })
                    )
                  : _c("tfoot", { staticClass: "foot" }, [
                      _c("tr", { staticClass: "row" }, [
                        !_vm.deviceMaintPlan.suitFlag
                          ? _c("td", { attrs: { colspan: "11" } }, [
                              _c("span", [_vm._v("未选择资产")])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.deviceMaintPlan.suitFlag
                          ? _c("td", { attrs: { colspan: "12" } }, [
                              _c("span", [_vm._v("未选择资产")])
                            ])
                          : _vm._e()
                      ])
                    ])
              ])
            ]
          )
        : _c(
            "div",
            {
              staticClass: "table-layout",
              staticStyle: { "overflow-x": "auto" }
            },
            [
              _vm.stateValue != null
                ? _c("div", { staticClass: "tab-container small base" }, [
                    _c("div", { staticClass: "tabs-nav" }, [
                      _c(
                        "ul",
                        { staticClass: "head" },
                        _vm._l(_vm.tableStateForCat, function(status) {
                          return _c(
                            "li",
                            {
                              staticClass: "head-item",
                              class: {
                                current: status.value == _vm.stateValue
                              },
                              on: {
                                click: function($event) {
                                  _vm.handleCatTabClick(status.value)
                                }
                              }
                            },
                            [_c("span", [_vm._v(_vm._s(status.text))])]
                          )
                        })
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("table", { staticClass: "custom-tbl error-prompt mt10" }, [
                _c("thead", { staticClass: "head" }, [
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "th",
                      { staticStyle: { "text-align": "left", width: "155px" } },
                      [_vm._v("资产描述全称")]
                    ),
                    _vm._v(" "),
                    _vm.deviceMaintPlan.suitFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              "text-align": "left",
                              width: "155px"
                            }
                          },
                          [_vm._v("套装名称")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "th",
                      { staticStyle: { "text-align": "left", width: "240px" } },
                      [_vm._v("系统编号")]
                    ),
                    _vm._v(" "),
                    _c("th", { staticStyle: { width: "155px" } }, [
                      _vm._v("质保到期时间")
                    ]),
                    _vm._v(" "),
                    _c(
                      "th",
                      { staticStyle: { "text-align": "left", width: "200px" } },
                      [_vm._v("供应商名称")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "required",
                        staticStyle: { "text-align": "left", width: "200px" }
                      },
                      [_vm._v("服务商名称")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "required",
                        staticStyle: { "text-align": "left", width: "150px" }
                      },
                      [_vm._v("基于合同")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "required",
                        staticStyle: { "text-align": "left", width: "150px" }
                      },
                      [_vm._v("服务名称")]
                    ),
                    _vm._v(" "),
                    _vm.deviceMaintPlan.cronFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              "text-align": "center",
                              width: "242px"
                            }
                          },
                          [_vm._v("首次工单截止时间")]
                        )
                      : _c(
                          "th",
                          {
                            staticStyle: {
                              "text-align": "center",
                              width: "242px"
                            }
                          },
                          [_vm._v("工单截止时间")]
                        ),
                    _vm._v(" "),
                    _vm.deviceMaintPlan.cronFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              "text-align": "right",
                              width: "120px"
                            }
                          },
                          [_vm._v("要求完成小时")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "right", width: "120px" }
                      },
                      [_vm._v("提前预警小时")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      { staticStyle: { "text-align": "left", width: "216px" } },
                      [_vm._v("操作")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.deviceMaintPlan.deviceSubNoCatList != null &&
                _vm.deviceMaintPlan.deviceSubNoCatList.length > 0
                  ? _c(
                      "tbody",
                      { staticClass: "body" },
                      _vm._l(_vm.deviceMaintPlan.deviceSubNoCatList, function(
                        deviceSubNo,
                        index
                      ) {
                        return _c("tr", { staticClass: "row" }, [
                          _c(
                            "td",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { title: deviceSubNo.title }
                            },
                            [_vm._v(_vm._s(deviceSubNo.title))]
                          ),
                          _vm._v(" "),
                          _vm.deviceMaintPlan.suitFlag
                            ? _c(
                                "td",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { title: deviceSubNo.suitName || "无" }
                                },
                                [_vm._v(_vm._s(deviceSubNo.suitName || "无"))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "left" } }, [
                            _vm._v(_vm._s(deviceSubNo.tmpNo))
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(deviceSubNo.wrntDueTime))]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              {
                                attrs: {
                                  title: _vm.roleMerchtVendor(deviceSubNo)
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.roleMerchtVendor(deviceSubNo))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              {
                                attrs: {
                                  title: _vm.roleMerchtServicer(deviceSubNo)
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.roleMerchtServicer(deviceSubNo))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            deviceSubNo.contractId != null
                              ? _c("span", [_vm._v("是")])
                              : _c("span", [_vm._v("否")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { title: deviceSubNo.servcTitle || "无" }
                            },
                            [_vm._v(_vm._s(deviceSubNo.servcTitle || "无"))]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticStyle: { "text-align": "center" } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      "picker-options": _vm.pickerOptions0,
                                      type: "datetime",
                                      placeholder: "请选择"
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.yqFinishTimeChange(deviceSubNo)
                                      }
                                    },
                                    model: {
                                      value: deviceSubNo.yqFinishTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          deviceSubNo,
                                          "yqFinishTime",
                                          $$v
                                        )
                                      },
                                      expression: "deviceSubNo.yqFinishTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.deviceMaintPlan.cronFlag
                            ? _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(deviceSubNo.yqFinishHours))
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticStyle: { "text-align": "right" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "deviceSubNoCatList." +
                                      index +
                                      ".yqFinishAotHr",
                                    rules: {
                                      validator: _vm.inputYqFinishAotHr,
                                      trigger: "blur"
                                    }
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "input-content-right",
                                    attrs: { type: "number", min: "0" },
                                    on: {
                                      change: function($event) {
                                        _vm.quantityYqFinishAotHr(deviceSubNo)
                                      }
                                    },
                                    model: {
                                      value: deviceSubNo.yqFinishAotHr,
                                      callback: function($$v) {
                                        _vm.$set(
                                          deviceSubNo,
                                          "yqFinishAotHr",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "deviceSubNo.yqFinishAotHr"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.selectServicer(deviceSubNo, index)
                                  }
                                }
                              },
                              [_vm._v("选择服务商")]
                            ),
                            _vm._v(" "),
                            deviceSubNo.ssuId == null
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.selectMsu(deviceSubNo, index)
                                      }
                                    }
                                  },
                                  [_vm._v("选择服务")]
                                )
                              : _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.removeMsu(deviceSubNo, index)
                                      }
                                    }
                                  },
                                  [_vm._v("移除服务")]
                                ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.deleteSelectDeviceSubNo(index)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          ])
                        ])
                      })
                    )
                  : _c("tfoot", { staticClass: "foot" }, [
                      _c("tr", { staticClass: "row" }, [
                        !_vm.deviceMaintPlan.suitFlag
                          ? _c("td", { attrs: { colspan: "11" } }, [
                              _c("span", [_vm._v("未选择资产")])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.deviceMaintPlan.suitFlag
                          ? _c("td", { attrs: { colspan: "12" } }, [
                              _c("span", [_vm._v("未选择资产")])
                            ])
                          : _vm._e()
                      ])
                    ])
              ])
            ]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f0201ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f0201ad","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/DeviceMaintPlanAdd.vue
// module id = 3060
// module chunks = 0